export default __webpack_public_path__ + "static/media/no-requests-found.3bb5c590.svg";